/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDRadiusUpRightIcon16Light } from './ArrowDRadiusUpRightIcon16Light';
import { ArrowDRadiusUpRightIcon16Regular } from './ArrowDRadiusUpRightIcon16Regular';
import { ArrowDRadiusUpRightIcon16Solid } from './ArrowDRadiusUpRightIcon16Solid';
import { ArrowDRadiusUpRightIcon20Light } from './ArrowDRadiusUpRightIcon20Light';
import { ArrowDRadiusUpRightIcon20Regular } from './ArrowDRadiusUpRightIcon20Regular';
import { ArrowDRadiusUpRightIcon20Solid } from './ArrowDRadiusUpRightIcon20Solid';
import { ArrowDRadiusUpRightIcon24Regular } from './ArrowDRadiusUpRightIcon24Regular';
import { ArrowDRadiusUpRightIcon24Solid } from './ArrowDRadiusUpRightIcon24Solid';
import { ArrowDRadiusUpRightIcon32Regular } from './ArrowDRadiusUpRightIcon32Regular';
import { ArrowDRadiusUpRightIcon64Regular } from './ArrowDRadiusUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDRadiusUpRightIcon16Light,
        regular: ArrowDRadiusUpRightIcon16Regular,
        solid: ArrowDRadiusUpRightIcon16Solid,
    },
    20: {
        light: ArrowDRadiusUpRightIcon20Light,
        regular: ArrowDRadiusUpRightIcon20Regular,
        solid: ArrowDRadiusUpRightIcon20Solid,
    },
    24: {
        regular: ArrowDRadiusUpRightIcon24Regular,
        solid: ArrowDRadiusUpRightIcon24Solid,
    },
    32: {
        regular: ArrowDRadiusUpRightIcon32Regular,
    },
    64: {
        regular: ArrowDRadiusUpRightIcon64Regular,
    },
};
export var ArrowDRadiusUpRightIcon = forwardRef('ArrowDRadiusUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
